class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
    
    //update PDN tracker and check for catalog variant with or without plants
    $.getJSON('/cart.js', function(cart) {
      let cartItems = cart.items;
      let variantIds = [];
      let plantCount = 0;
      cartItems.forEach(function(item) {                  
        if (!isNaN(item.sku)) {
          plantCount += item.quantity;
        }
        variantIds.push(item.variant_id);
      });
      
      //set plant tracker header image based on number of plants in cart.
      if (plantCount < 6) {
        $('#header-plant-tracker').attr("src","//cdn.shopify.com/s/files/1/1527/8799/t/7/assets/plant-tracker-"+plantCount+".jpg");			 									
      } else {
        $('#header-plant-tracker').attr("src","//cdn.shopify.com/s/files/1/1527/8799/t/7/assets/plant-tracker-6.jpg");
      } 
      
      if ((variantIds.indexOf(21434183749) > -1) && (variantIds.length > 1)) {
        $.post('/cart/update.js', {updates: {21434183749: 0, 21434159557: 1}});
        console.log("plants detected");
      }
      if ((variantIds.indexOf(21434159557) > -1) && (variantIds.length == 1)) {
        $.post('/cart/update.js', {updates: {21434183749: 1, 21434159557: 0}});
        console.log("no plants detected");
      }  
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
